import { motion } from "framer-motion";

const VALUES = [
  { letter: "V", word: "Vision", desc: "VLMAG envisions a future beyond the present, creating innovative solutions that drive progress." },
  { letter: "L", word: "Legacy", desc: "VLMAG aspires to create enduring works, narratives, and platforms that leave a lasting impact on society." },
  { letter: "M", word: "Movement", desc: "VLMAG fosters collaboration among creatives, culture, fashion, music, and art — propelling ideas forward and driving innovation." },
  { letter: "A", word: "Art", desc: "VLMAG utilizes creativity as a universal language to express identity, emotions, and cultural narratives." },
  { letter: "G", word: "Growth", desc: "VLMAG cultivates opportunities that empower artists and creatives to expand their personal, professional, and financial horizons." },
];

export const StandsFor = () => {
  return (
    <section id="stands-for" data-testid="stands-for" className="relative bg-black px-5 md:px-10 py-16 md:py-28 border-t border-white/10">
      <div className="flex items-center gap-3 mb-10 md:mb-16">
        <span className="text-[10px] md:text-xs uppercase tracking-[0.3em] font-bold text-[#E30613]">What We Stand For</span>
        <span className="h-px flex-1 bg-white/10" />
      </div>

      <h2 className="font-display uppercase leading-[0.88] tracking-tight text-4xl sm:text-5xl md:text-7xl mb-12 md:mb-20 max-w-4xl">
        What Does <span className="text-[#E30613]">VLMAG</span> Stand For?
      </h2>

      <div className="divide-y divide-white/10 border-y border-white/10">
        {VALUES.map((v, i) => (
          <motion.div
            key={v.letter}
            data-testid={`stands-for-${v.word.toLowerCase()}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
            className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-12 items-start hover:bg-white/[0.02] transition-colors duration-500"
          >
            <div className="md:col-span-2 flex items-baseline gap-4">
              <span className="font-display leading-none text-6xl md:text-8xl text-[#E30613] transition-transform duration-500 group-hover:translate-x-2">{v.letter}</span>
            </div>
            <div className="md:col-span-3">
              <h3 className="font-display uppercase tracking-tight text-3xl md:text-4xl text-white leading-none">{v.word}</h3>
            </div>
            <div className="md:col-span-7">
              <p className="text-base md:text-lg text-neutral-400 leading-relaxed max-w-2xl">{v.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
